/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RegisterStorageAccountRequest,
  StorageAccountResponse,
  StorageAccountValidationResult,
  UpdateStorageAccountRequest,
} from '../models/index';
import {
    RegisterStorageAccountRequestFromJSON,
    RegisterStorageAccountRequestToJSON,
    StorageAccountResponseFromJSON,
    StorageAccountResponseToJSON,
    StorageAccountValidationResultFromJSON,
    StorageAccountValidationResultToJSON,
    UpdateStorageAccountRequestFromJSON,
    UpdateStorageAccountRequestToJSON,
} from '../models/index';

export interface DisableAccountRequest {
    customerId: string;
    accountId: string;
    sessionId?: string;
}

export interface GetAccountRequest {
    customerId: string;
    accountId: string;
    sessionId?: string;
}

export interface ListAccountsRequest {
    customerId: string;
    sessionId?: string;
}

export interface RegisterAccountRequest {
    customerId: string;
    registerStorageAccountRequest: RegisterStorageAccountRequest;
    sessionId?: string;
}

export interface UpdateAccountRequest {
    customerId: string;
    accountId: string;
    updateStorageAccountRequest: UpdateStorageAccountRequest;
    sessionId?: string;
}

export interface ValidateAccountRequest {
    customerId: string;
    accountId: string;
    sessionId?: string;
}

/**
 * CustomerStorageAccountsApi - interface
 * 
 * @export
 * @interface CustomerStorageAccountsApiInterface
 */
export interface CustomerStorageAccountsApiInterface {
    /**
     * 
     * @summary Disable storage account
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    disableAccountRaw(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disable storage account
     */
    disableAccount(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get storage account
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>>;

    /**
     * Get storage account
     */
    getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse>;

    /**
     * 
     * @summary List storage accounts for customer
     * @param {string} customerId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    listAccountsRaw(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List storage accounts for customer
     */
    listAccounts(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Register external storage account (Azure Blob + service principal)
     * @param {string} customerId 
     * @param {RegisterStorageAccountRequest} registerStorageAccountRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    registerAccountRaw(requestParameters: RegisterAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>>;

    /**
     * Register external storage account (Azure Blob + service principal)
     */
    registerAccount(requestParameters: RegisterAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse>;

    /**
     * 
     * @summary Update storage account metadata or credentials
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {UpdateStorageAccountRequest} updateStorageAccountRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>>;

    /**
     * Update storage account metadata or credentials
     */
    updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse>;

    /**
     * 
     * @summary Validate connection and provision platform container
     * @param {string} customerId 
     * @param {string} accountId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerStorageAccountsApiInterface
     */
    validateAccountRaw(requestParameters: ValidateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountValidationResult>>;

    /**
     * Validate connection and provision platform container
     */
    validateAccount(requestParameters: ValidateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountValidationResult>;

}

/**
 * 
 */
export class CustomerStorageAccountsApi extends runtime.BaseAPI implements CustomerStorageAccountsApiInterface {

    /**
     * Disable storage account
     */
    async disableAccountRaw(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling disableAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling disableAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/storage/accounts/{accountId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disable storage account
     */
    async disableAccount(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get storage account
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/storage/accounts/{accountId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageAccountResponseFromJSON(jsonValue));
    }

    /**
     * Get storage account
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List storage accounts for customer
     */
    async listAccountsRaw(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listAccounts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/storage/accounts`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List storage accounts for customer
     */
    async listAccounts(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register external storage account (Azure Blob + service principal)
     */
    async registerAccountRaw(requestParameters: RegisterAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling registerAccount().'
            );
        }

        if (requestParameters['registerStorageAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'registerStorageAccountRequest',
                'Required parameter "registerStorageAccountRequest" was null or undefined when calling registerAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{customerId}/storage/accounts`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterStorageAccountRequestToJSON(requestParameters['registerStorageAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageAccountResponseFromJSON(jsonValue));
    }

    /**
     * Register external storage account (Azure Blob + service principal)
     */
    async registerAccount(requestParameters: RegisterAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse> {
        const response = await this.registerAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update storage account metadata or credentials
     */
    async updateAccountRaw(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateStorageAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStorageAccountRequest',
                'Required parameter "updateStorageAccountRequest" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{customerId}/storage/accounts/{accountId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStorageAccountRequestToJSON(requestParameters['updateStorageAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageAccountResponseFromJSON(jsonValue));
    }

    /**
     * Update storage account metadata or credentials
     */
    async updateAccount(requestParameters: UpdateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountResponse> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate connection and provision platform container
     */
    async validateAccountRaw(requestParameters: ValidateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageAccountValidationResult>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling validateAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling validateAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/storage/accounts/{accountId}/validate`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageAccountValidationResultFromJSON(jsonValue));
    }

    /**
     * Validate connection and provision platform container
     */
    async validateAccount(requestParameters: ValidateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageAccountValidationResult> {
        const response = await this.validateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
